// src/utils/globalStyles.js
// All global CSS in one place — injected once via injectGlobalStyles()

const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=Courier+Prime:ital,wght@0,400;0,700;1,400&display=swap');

:root {
  --ink:           #0a0705;
  --paper:         #f2ead8;
  --paper2:        #e8dcc4;
  --blood:         #8b1a1a;
  --blood-bright:  #c0392b;
  --gold:          #c9a84c;
  --gold-dim:      #8a6d2f;
  --doctor-teal:   #1a5c5c;
  --citizen-navy:  #1a2a4a;
}

*, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #root { height: 100%; min-height: 100vh; }

body {
  background: var(--ink);
  color: var(--paper);
  font-family: 'Courier Prime', monospace;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

body::before {
  content: '';
  position: fixed; inset: 0;
  pointer-events: none; z-index: 0;
  background:
    radial-gradient(ellipse at 20% 10%, rgba(139,26,26,0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 90%, rgba(26,26,60,0.2)   0%, transparent 50%),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4'%3E%3Crect width='4' height='4' fill='%230a0705'/%3E%3Crect x='0' y='0' width='1' height='1' fill='%23ffffff' opacity='0.03'/%3E%3C/svg%3E");
}

#root { position: relative; z-index: 1; }

/* ── Animations ── */
@keyframes fadeInUp   { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
@keyframes fadeIn     { from { opacity:0; } to { opacity:1; } }
@keyframes cardReveal { from { transform:scale(0.6) rotateY(90deg); opacity:0; } to { transform:scale(1) rotateY(0deg); opacity:1; } }
@keyframes cardFlipOut{ from { transform:scale(1) rotateY(0deg); opacity:1; } to { transform:scale(0.6) rotateY(-90deg); opacity:0; } }
@keyframes pulse      { 0%,100% { opacity:0.4; } 50% { opacity:1; } }
@keyframes slideIn    { from { opacity:0; transform:translateX(-10px); } to { opacity:1; transform:translateX(0); } }
@keyframes toastIn    { from { transform:translateX(110%); opacity:0; } to { transform:translateX(0); opacity:1; } }
@keyframes toastOut   { from { opacity:1; } to { opacity:0; transform:translateX(110%); } }
@keyframes voteGlow   { 0%,100% { box-shadow:none; } 50% { box-shadow:0 0 14px rgba(201,168,76,0.5); } }
@keyframes spin       { to { transform: rotate(360deg); } }

/* ── Scrollbar ── */
::-webkit-scrollbar            { width: 4px; }
::-webkit-scrollbar-track      { background: transparent; }
::-webkit-scrollbar-thumb      { background: rgba(201,168,76,0.25); border-radius: 2px; }

/* ── Role card flip ── */
.role-flip-enter  { animation: cardReveal  0.6s cubic-bezier(0.34,1.56,0.64,1) forwards; }
.role-flip-exit   { animation: cardFlipOut 0.45s ease-in forwards; }

/* ── Mobile tweaks ── */
@media (max-width: 640px) {
  body { font-size: 15px; }
}

@media (max-width: 640px) {
  .game-grid { grid-template-columns: 1fr !important; }
  .lobby-grid { grid-template-columns: 1fr !important; }
}
`;

export default GLOBAL_CSS;
